<template>
  <div class="content">
    <s-location info title="관련 규정"/>
      <div v-html="sitem.cont" />
  </div>
</template>



<script>
export default {
  data() {
    return {
      sitem: {},
    }
  },

  created() {
    this.getData()
  },

  methods: {
    getData() {

      this.$ui.httpGet(
        "/proc/N_CMS_SEL_DTL_ADM",
        { seq : '2'}, // TB_CMS 테이블의 [관련 규정] 게시글로 고정
        ret => this.sitem = ret.data.rs1[0]
      )

    }
  },
}
</script>